const createHTMLElement = require("../dom/createHTMLElement");

/**
 * @param marketoForm {MarketoForm}
 * @param countryField {HTMLSelectElement}
 * @return {void}
 */
module.exports = function copyCountryOptionsFromMarketoFormIntoNativeFormCountrySelect(marketoForm, countryField) {
    const $countryOptions = marketoForm.getFormElem()
        .find("[name=Country]")
        .find("option");

    countryField.innerHTML = '';

    let options = [
        `<option value="">Country/Permanent Residence</option>`,
        '',
        '',
        ''
    ];
    for (let countryOption of $countryOptions) {
        const value = countryOption.getAttribute("value");

        const option = `<option value="${value}">${countryOption.innerText}</option>`;

        switch (value) {
            case '': {
                break;
            }

            case 'United States': {
                options[1] = option;
                break;
            }

            case 'United Kingdom': {
                options[2] = option;
                break;
            }

            case 'Canada': {
                options[3] = option;
                break;
            }

            default: {
                options.push(option);
            }
        }
    }

    for (let option of options) {
        const optionElement = createHTMLElement(option);
        countryField.append(optionElement);
    }
}
